export default {
  modalBackground: Styles.color.white,
  disclaimerColor: Styles.color.black,
};
